var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleTradeFinanceProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b2b2b;}.cls-2{fill:#e30613;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.08,253.12H57.91V168.73H94.08Zm-29.17-7H87.08V175.73H64.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.67,253.12H109.51V149.66h36.16Zm-29.16-7h22.16V156.66H116.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.38,253.12H162.22V119.38h36.16Zm-29.16-7h22.16V126.38H169.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.85,253.12H212.69V79h36.16Zm-29.16-7h22.16V86H219.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.66,156.37,50.85,136l3.49-.31c.91-.09,92.77-9.41,167.35-87.71l2.41-2.54,14.81,14.11-2.41,2.53c-80.25,84.27-176.31,93.63-180.36,94Zm5.78-14.15.57,6.47c17.95-2.33,99.56-16.6,170-88.92l-4.67-4.46C156.49,124.9,76,139.74,58.44,142.22Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleTradeFinanceProducts);
export default __webpack_public_path__ + "static/media/MultipleTradeFinanceProducts.428e144e9ab047709d68eb56fa0d2278.svg";
export { ForwardRef as ReactComponent };